var exports = {
  "Io": "xcc377c0b--21e031--distance",
  "wJ": "xcc377c0b--21e031--distance-icon",
  "Ew": "xcc377c0b--21e031--distance-text",
};

module.exports = exports;
